import React from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

/**
 * A table row whose detail opens directly beneath it.
 *
 * Detail used to render below the *whole table*, so reviewing row 20 of 25
 * scrolled the record you were looking at off screen and lost your place in the
 * list. Opening in place keeps the surrounding rows visible, which is what
 * makes a queue scannable - an operator comparing three stuck transfers should
 * not have to remember what the last one said.
 *
 * The open row is owned by the caller (and kept in the URL), so a shared or
 * refreshed link reopens the same record.
 */
export function ExpandableRow({
  children,
  detail,
  expanded,
  onToggle,
  columnCount,
  label = "row",
}) {
  return (
    <>
      <tr
        onClick={onToggle}
        className={`cursor-pointer transition-colors ${
          expanded ? "bg-[#F5F9F4]" : "hover:bg-[#F5F9F4]/50"
        }`}
      >
        <td className="py-4 pr-2 w-8 align-top">
          {/* A real button so the row is reachable and operable by keyboard;
              the row click is a convenience on top of it, not the only way in. */}
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              onToggle();
            }}
            aria-expanded={expanded}
            aria-label={`${expanded ? "Hide" : "Show"} details for ${label}`}
            className="p-1 rounded-lg text-slate-400 hover:text-[#0A4730] hover:bg-white transition"
          >
            {expanded ? <ChevronDown size={15} /> : <ChevronRight size={15} />}
          </button>
        </td>
        {children}
      </tr>
      {expanded && (
        <tr className="bg-[#F5F9F4]/60">
          <td colSpan={columnCount} className="px-4 pb-5 pt-1">
            {detail}
          </td>
        </tr>
      )}
    </>
  );
}
